// extracted by mini-css-extract-plugin
export default {"switchWrapper":"SwitchTab_switchWrapper__UhmeL"};